import { createIcon } from '@chakra-ui/react'

export const AssetsIcon = createIcon({
  displayName: 'Assets',
  path: (
    <path
      fill='currentColor'
      d='M16.726,12.641c-0.843,1.363-3.535,2.361-6.726,2.361s-5.883-0.998-6.727-2.361  
	C3.095,12.351,3,12.506,3,12.648c0,0.144,0,2.002,0,2.002c0,1.94,3.134,3.95,7,3.95s7-2.01,7-3.949c0,0,0-1.858,0-2.002
	C17,12.506,16.904,12.351,16.726,12.641z M16.737,7.525c-0.83,1.205-3.532,2.09-6.737,2.09S4.092,8.73,3.262,7.525
	C3.091,7.277,3,7.412,3,7.523C3,7.636,3,9.88,3,9.88c0,1.762,3.134,3.189,7,3.189s7-1.428,7-3.189c0,0,0-2.244,0-2.357
	C17,7.412,16.908,7.277,16.737,7.525z M10,1C6.134,1,3,2.18,3,3.633v1.26c0,1.541,3.134,2.791,7,2.791s7-1.25,7-2.791v-1.26
	C17,2.18,13.866,1,10,1z'
    />
  ),
  viewBox: '0 0 20 20'
})
